
import Login from './KeycloackLoginForm';
const LoginPage = () => {
  return ( <Login/> );
};

export default LoginPage;
